import LangEnum from '../../../../lang/LangEnum';
import { useTranslation } from '../../../translation/TranslationContext';
import { useRachelChatContext } from '../../contexts/Rachel.context';
import { PRODUCT_COLOR_ENTITY } from '../../rachelPageContext.utils';
import { useRachelStore } from '../../store/rachel.store';
import { selectRachelFocusedLabel } from '../../store/rachel.store.selectors';

const FOCUSED_ENTITY_FALLBACK_LABEL: Partial<Record<string, LangEnum>> = {
  [PRODUCT_COLOR_ENTITY]: LangEnum.GLOBAL_PRODUCT,
};

export const useRachelContextChip = () => {
  const { translate } = useTranslation();
  const { currentPageContext, isPageContextDismissed, dismissPageContext } = useRachelChatContext();
  const focusedLabel = useRachelStore(selectRachelFocusedLabel);

  if (isPageContextDismissed) {
    return null;
  }

  const { focusedEntity, focusedEntityId, label: pageLabel } = currentPageContext;
  const fallbackKey = focusedEntity ? FOCUSED_ENTITY_FALLBACK_LABEL[focusedEntity] : undefined;
  const fallbackLabel = fallbackKey ? translate(fallbackKey) : pageLabel;
  const label = focusedEntityId ? (focusedLabel ?? fallbackLabel) : pageLabel;

  return { label, onDismiss: dismissPageContext };
};
